<template>
  <global-active-filters :activeFilters="activeFilters" />
</template>

<script>
import moment from 'moment';
import {
  capitalize,
} from '@/helpers';

const GlobalActiveFilters = () => import('@/components/global/ActiveFilters.vue');

export default {
  name: 'ActiveFilters',
  components: {
    GlobalActiveFilters,
  },
  computed: {
    dropdowns() {
      return this.$store.state.app.dropdowns;
    },
    activeFilters() {
      const activeFilters = [];
      if (this.value.date_range !== 'all') {
        const dateRange = this.value.date_range;
        let dateText = '';
        if (dateRange === 'date') {
          dateText = moment(this.value.date_from).format('MMM DD, YYYY');
        } else if (dateRange === 'month') {
          dateText = moment(this.value.date_from).format('MMM YYYY');
        } else if (dateRange === 'year') {
          dateText = moment(this.value.date_from).format('YYYY');
        }
        activeFilters.push({
          text: `Date: ${dateText}`,
          fn: () => {
            this.value.date_from = null;
            this.value.date_to = null;
            this.value.date_range = 'all';
            this.$emit('refresh');
          },
        });
      }
      if (this.value.candle_status !== null) {
        activeFilters.push({
          text: `Status: ${capitalize(this.value.candle_status)}`,
          fn: () => {
            this.value.candle_status = null;
            this.$emit('refresh');
          },
        });
      }
      if (this.value.is_favorite !== null) {
        activeFilters.push({
          text: `Favorite: ${this.value.is_favorite ? 'Yes' : 'No'}`,
          fn: () => {
            this.value.is_favorite = null;
            this.$emit('refresh');
          },
        });
      }
      if (this.value.search !== '') {
        activeFilters.push({
          text: `Search: ${this.value.search}`,
          fn: () => {
            this.value.search = '';
            this.$emit('refresh');
          },
        });
      }
      if (this.value.brand_id !== null) {
        const brandText = this.dropdowns.candle_brand.find(
          (option) => option.value === this.value.brand_id,
        ).text;
        activeFilters.push({
          text: `Brand: ${brandText}`,
          fn: () => {
            this.value.brand_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.glass_id !== null) {
        const glassText = this.dropdowns.glass.find(
          (option) => option.value === this.value.glass_id,
        ).text;
        activeFilters.push({
          text: `Glass: ${glassText}`,
          fn: () => {
            this.value.glass_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.wax_id !== null) {
        const waxText = this.dropdowns.wax.find(
          (option) => option.value === this.value.wax_id,
        ).text;
        activeFilters.push({
          text: `Wax: ${waxText}`,
          fn: () => {
            this.value.wax_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.wick_id !== null) {
        const wickText = this.dropdowns.wick.find(
          (option) => option.value === this.value.wick_id,
        ).text;
        activeFilters.push({
          text: `Wick: ${wickText}`,
          fn: () => {
            this.value.wick_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.dye_name_id !== null) {
        const dyeText = this.dropdowns.dye.find(
          (option) => option.value === this.value.dye_name_id,
        ).text;
        activeFilters.push({
          text: `Dye: ${dyeText}`,
          fn: () => {
            this.value.dye_name_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.fragrance_name_id !== null) {
        const fragranceText = this.dropdowns.fragrance.find(
          (option) => option.value === this.value.fragrance_name_id,
        ).text;
        activeFilters.push({
          text: `Fragrance: ${fragranceText}`,
          fn: () => {
            this.value.fragrance_name_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.fragrance_pct_id !== null) {
        const fragrancePctText = this.dropdowns.fragrance_pct.find(
          (option) => option.value === this.value.fragrance_pct_id,
        ).text;
        activeFilters.push({
          text: `Fragrance %: ${fragrancePctText}`,
          fn: () => {
            this.value.fragrance_pct_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.additive_name_id !== null) {
        const additiveText = this.dropdowns.additive.find(
          (option) => option.value === this.value.additive_name_id,
        ).text;
        activeFilters.push({
          text: `Additive: ${additiveText}`,
          fn: () => {
            this.value.additive_name_id = null;
            this.$emit('refresh');
          },
        });
      }

      if (this.value.additive_pct_id !== null) {
        const additivePctText = this.dropdowns.additive_pct.find(
          (option) => option.value === this.value.additive_pct_id,
        ).text;
        activeFilters.push({
          text: `Additive %: ${additivePctText}`,
          fn: () => {
            this.value.additive_pct_id = null;
            this.$emit('refresh');
          },
        });
      }

      return activeFilters;
    },
  },
  props: {
    value: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>
